<p-toast></p-toast>

<div class="card customCard" *ngIf="idrol === 1 || idrol === 2">
    <p-table responsiveLayout="stack" [value]="devices" breakpoint="1050px">

        <ng-template pTemplate="caption" class="captionCustom">
            <span class="csf5">{{ 'WHATSAPP_DEVICES' | translate }}</span>
        </ng-template>

        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="tableHeading">{{ 'NAME' | translate }}</th>
                <th class="tableHeading">{{ 'TOKEN' | translate }}</th>
                <th class="tableHeading">{{ 'START_DATE' | translate }}</th>
                <th class="tableHeading">{{ 'END_DATE' | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-device let-columns="columns">
            <tr [ngClass]="{'expired-row': device.isExpired }" pTooltip="El dispositivo ha expirado" 
                tooltipPosition="top" [tooltipDisabled]="!device.isExpired">
                <td>
                    <span class="p-column-title tableHeading">{{ 'NAME' | translate }}</span>
                    <div class="pT-12">
                        <h5 class="customFont3">{{ getDeviceName(device) }}</h5>
                    </div>
                </td>
                <td>
                    <span class="p-column-title tableHeading">{{ 'TOKEN' | translate }}</span>
                    <div class="pT-12">
                        <a *ngIf="device.url !== null && !device.isExpired" (click)="vincularRedireccionar(device)" style="cursor: pointer;">
                            <span class="customFont1">{{device.token}}</span>
                        </a>
                    </div>
                    <div class="pT-12">
                        <span *ngIf="device.url === null || device.isExpired" class="customFont2">{{device.token}}</span>
                    </div>
                </td>
                <td>
                    <span class="p-column-title tableHeading">{{ 'START_DATE' | translate }}</span>
                    <h5 class="customFont3">{{device.startDate | date:'dd/MM/yyyy'}}</h5>
                </td>
                <td>
                    <span class="p-column-title tableHeading">{{ 'END_DATE' | translate }}</span>
                    <h5 class="customFont3">{{device.endDate | date:'dd/MM/yyyy'}}</h5>
                </td>
                <td style="text-align: left;">
                    <i class="pi pi-file-edit icon-table-custom" (click)="redirectConnect(device)"
                        pTooltip="{{ 'EDIT_DEVICE' | translate }}"></i>

                    <i *ngIf="!device.connected && !mapDeviceConnected.get(device.id)" 
                        [class]="mapIconoDispositivo.get(device.esOficial)" (click)="vincularRedireccionar(device)"
                        [pTooltip]="mapActivarDispositivo.get(device.esOficial)"></i>

                    <i *ngIf="mapDeviceConnected.get(device.id)" class="pi pi-spin pi-spinner icon-table-custom"></i>

                    <i *ngIf="device.connected && !mapDeviceConnected.get(device.id)" 
                        class="pi pi-power-off icon-table-custom" (click)="desconectar(device)"
                        [pTooltip]="mapDesactivarDispositivo.get(device.esOficial)"></i>
                        <div *ngIf="deviceSincronizar === device.id">
                            <i class="pi pi-spin pi-spinner icon-table-custom"></i>
                            <span class="tableHeading">{{ 'SYNCING_MESSAGES' | translate }}</span>
                        </div>
                        
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<p-confirmDialog class="custom-confirm-dialog" [style]="{width: '50vw'}" acceptLabel="{{ 'CONFIRM' | translate }}" rejectLabel="{{ 'CANCEL' | translate }}"></p-confirmDialog>
